import React from "react";
import { RouteObject } from "react-router";
import { LoggedInProps } from "modules/common/components/routing/AnonymousRoute";
import { ProtectedRoute } from "modules/common/components/routing/ProtectedRoute";
import { routes } from "modules/common/routes";
import { FinanceRequestsPage } from "./finance-requests/components/FinanceRequesPage";
import { FinanceRequestsStoreType } from "./finance-requests/models/finance-requests-store";
import { SessionType } from "modules/session/auth/models/session";
import { ImportSpendingsStoreType } from "./import/models/import-store";
import { ExpensesPage } from "./components/ExpensesPage";
import { SpendingsListType } from "./summary/models/spending-list";
import { OverheadSpendingsType } from "./overhead/models/overhead-spendings";

export const buildRoutes = ({
    requestsStore,
    importStore,
    spendingsStore,
    overheadStore,
    session,
    loggedIn,
}: RoutesProps): RouteObject[] => [
    {
        path: `${routes.expenses.path}/*`,
        element: (
            <ProtectedRoute loggedIn={loggedIn}>
                <ExpensesPage
                    importStore={importStore}
                    spendingsStore={spendingsStore}
                    overheadStore={overheadStore}
                    session={session}
                />
            </ProtectedRoute>
        ),
    },
    {
        path: `${routes.financeRequests.path}/*`,
        element: (
            <ProtectedRoute loggedIn={loggedIn}>
                <FinanceRequestsPage store={requestsStore} session={session} />
            </ProtectedRoute>
        ),
    },
];

interface RoutesProps extends LoggedInProps {
    requestsStore: FinanceRequestsStoreType;
    importStore: ImportSpendingsStoreType;
    spendingsStore: SpendingsListType;
    overheadStore: OverheadSpendingsType;
    session: SessionType;
}
